import { useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslations } from "next-intl";

import { ShowWhen } from "@/components/common";
import NotificationsList from "./notifications-list";
import { CloseModalIcon, NotificationIcon } from "@/components/assets/icons";
import { useOutsideClickDetector } from "@/hooks/useOutsideClickDetector";
import { apiRequest } from "@/utils/apiRequest";

import { GET_LAST_SHIPMENT_STATUSES } from "@/constants/Query";
import { IShipmentStatus } from "@/types/apiResponse.types";

const Notifications = () => {
  const [isOpened, setIsOpened] = useState(false);
  const ref = useRef(null);

  const t = useTranslations();

  useOutsideClickDetector(ref, () => {
    setIsOpened(false);
  });

  const handleToggle = () => {
    setIsOpened(!isOpened);
  };

  const { data } = useQuery<{
    data: {
      data: IShipmentStatus[];
    };
  }>({
    queryKey: [GET_LAST_SHIPMENT_STATUSES],
    queryFn: () => apiRequest(GET_LAST_SHIPMENT_STATUSES, "get", {}),
  });

  const notificationsData = data?.data?.data || [];

  return (
    <div
      className="relativef h-[50px] w-[50px] rounded-full bg-white p-4"
      ref={ref}
    >
      <div
        onClick={handleToggle}
        className="relative flex cursor-pointer items-center justify-center"
      >
        <NotificationIcon />
        <ShowWhen condition={isOpened}>
          <div className="absolute left-[-5rem] top-[70px] z-20 w-[25rem] rounded-[20px] bg-white shadow-sm">
            <div className="absolute left-[4.5rem] top-[-15px] h-0 w-0 border-b-[28px] border-l-[14px] border-r-[14px] border-b-white border-l-transparent border-r-transparent" />
            <div className="flex w-full items-center justify-between border-b border-[#f5f5f5] p-5">
              <h3 className="text-base font-bold">{t("notifications")}</h3>
              <div
                onClick={() => setIsOpened(false)}
                className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-zinc-100"
              >
                <CloseModalIcon className="h-6 w-6" />
              </div>
            </div>
            <NotificationsList notificationsData={notificationsData} />
          </div>
        </ShowWhen>
      </div>
    </div>
  );
};

export { Notifications };
